const MAX_POSTGRESQL_INT_VALUE = 2147483647;

/**
 * Nous utilisons des slugs avec un id en base 36 à la fin.
 * Cette fonction extrait cet id et le transform en nombre en base 10.
 */
export const extractBase36Id = (
  slug?: string | string[]
): number | undefined => {
  if (!slug || Array.isArray(slug)) {
    return undefined;
  }

  const idBase36 = slug.split('-').pop();
  if (!idBase36) {
    return undefined;
  }

  const idInt = parseInt(idBase36, 36);
  if (idInt > MAX_POSTGRESQL_INT_VALUE) {
    return undefined;
  }

  return idInt;
};
